import * as React from 'react';
import { MediaQuery, Expandable, RichTextArea } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const SearchPageDescription = ({ description  })=>{
    const { getLabel  } = useIntl();
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const initialHeight = isMobile ? 64 : 72;
    return /*#__PURE__*/ React.createElement(Expandable, {
        id: "searchpage-description",
        className: "searchpage-description",
        showLessLabel: `- ${getLabel('search.filters.showLess')}`,
        showMoreLabel: `+ ${getLabel('search.filters.showMore')}`,
        initialHeight: initialHeight
    }, /*#__PURE__*/ React.createElement(RichTextArea, {
        content: description,
        className: "searchpage-description__body"
    }));
};

export { SearchPageDescription, SearchPageDescription as default };
//# sourceMappingURL=SearchPageDescription.js.map
